import { css } from 'styled-components';
import type { Keyframes } from 'styled-components';

export function tabAnimationCss([
  name,
  duration,
  easing,
  delay,
]: [Keyframes | string, number, string, number]) {
  if (name === 'none') {
    return '';
  }
  return css`
  animation: ${name} ${duration}ms ${easing} ${delay}ms 1 backwards;
  `;
}
